import { render } from "./CodeReviewReport.vue?vue&type=template&id=7e36736f&scoped=true"
import script from "./CodeReviewReport.vue?vue&type=script&lang=js"
export * from "./CodeReviewReport.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=7e36736f&scoped=true&lang=css&external"
import "./CodeReviewReport.vue?vue&type=style&index=1&id=7e36736f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e36736f"]])

export default __exports__